const vacantProperties = 'property'
import Constant from '@/js/constant.js'
const HOST = Constant.hosts.url
import axios from 'axios'

export default {
  getVacantProperties (context) {
    let params = {query: context.searchQuery, page: context.slectedPage - 1}
    if (params !== {}) {
      params = {params: {query: context.searchQuery, page: context.slectedPage - 1}}
    } else {
      params = { params: {} }
    }
    axios.get(vacantProperties, params).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setVacantProperties(response.data)
    }, () => {
    })
  },
  uploadFile (context, propertyId, file, position) {
    const token = window.localStorage.getItem('access_token')
    const instance = axios.create({
      baseURL: `${HOST}`,
      timeout: 100000,
      headers: {'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${token}`}
    })
    const params2 = {property_id: propertyId}
    const params1 = { params: params2 }
    instance.post(`${vacantProperties}/upload_file`, file, params1).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.fileUploaded(response.data, position)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      if (error.response !== undefined) {
        context.fileNotUploaded(error.response.data.return_message, position)
      } else {
        context.fileNotUploaded(error, position)
      }
    })
  },
  addVacantProperty (context, body) {
    axios.post(vacantProperties, body).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.vacantPropertyAdded(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.vacantPropertyNotAdded(error.response.data.return_message)
    })
  },
  updateVacantProperty (context, id, body) {
    axios.put(`${vacantProperties}/${id}`, body).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.vacantPropertyUpdated(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.vacantPropertyNotUpdated(error.response.data.return_message)
    })
  },
  getVacantPropertyById (context, id) {
    axios.get(`${vacantProperties}/${id}`).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setVacantProperty(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setVacantPropertyNotFound(error.response.data.return_message)
    })
  }
}